export default "__VITE_ASSET__b500c0fb__"